exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1DCcw6PXcCmMQ4YvaeU3PF {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n._1DCcw6PXcCmMQ4YvaeU3PF:first-child {\n  margin-top: 1rem;\n  margin-bottom: 2rem;\n}\n._1DCcw6PXcCmMQ4YvaeU3PF img {\n  height: 1.5rem;\n  margin-right: 1rem;\n}\n._3X1O3MGtU_hVO4SMME865U {\n  margin-top: 0.5rem;\n}\n._2dlnND_koA8D2eqAB4tmrK {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n._2dlnND_koA8D2eqAB4tmrK > div:last-child {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 0;\n}\n._34hyAU-ShgqnQxXhQD0nVd {\n  margin-bottom: 2rem;\n  width: 500px!important;\n}\n._2dZ7boJmTZjrCIvAB1bwZc {\n  width: 500px;\n}\n._2dZ7boJmTZjrCIvAB1bwZc > section:first-child {\n  padding-bottom: 0;\n}\n._2dZ7boJmTZjrCIvAB1bwZc > div:last-child {\n  margin-top: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"settings": "_1DCcw6PXcCmMQ4YvaeU3PF",
	"hint": "_3X1O3MGtU_hVO4SMME865U",
	"container": "_2dlnND_koA8D2eqAB4tmrK",
	"infoBox": "_34hyAU-ShgqnQxXhQD0nVd",
	"formBox": "_2dZ7boJmTZjrCIvAB1bwZc"
};